import React from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const StepContactoForm = ({
  modoEdicion,
  nuevoContactos,
  nuevoNombreContacto,
  setNuevoNombreContacto,
  nuevoTipoContacto,
  setNuevoTipoContacto,
  nuevoTelefonoContacto,
  nuevoCorreoContacto,
  codigoPaisContacto,
  setCodigoPaisContacto,
  indiceEdicionContacto,
  codigosPaises,
  handleTelefonoContactoChange,
  handleCorreoContactoChange,
  handleGuardarContacto,
  handleEliminarContacto,
  handleDesactivarContacto,
  handleSeleccionarContacto,
  onPrev,
}) => {
  return (
    <div className="card">
      <div className="p-d-flex p-jc-between p-ai-center mb-3">
        <div>
          <h6>Ingrese los contactos a registrar</h6>
        </div>
      </div>

      <div className="p-fluid formgrid grid">
        {/* Tipo */}
        <div className="field col-12 md:col-2">
          <label>Tipo</label>
          <Dropdown
            id="tipoContacto"
            value={nuevoTipoContacto}
            onChange={(e) => setNuevoTipoContacto(e.value)}
            options={[
              { name: "COMERCIAL", value: "COMERCIAL" },
              { name: "NATURAL", value: "NATURAL" },
              { name: "OTRO", value: "OTRO" },
            ]}
            optionLabel="name"
            placeholder="Seleccione una opción"
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
          />
        </div>

        {/* Nombre */}
        <div className="field col-12 md:col-2">
          <label>Nombre</label>
          <InputText
            id="NombreContacto"
            type="text"
            value={nuevoNombreContacto || ""}
            onChange={(e) => setNuevoNombreContacto(e.target.value.toUpperCase())}
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
            placeholder="Ingrese Nombre"
            maxLength={45}
          />
        </div>

        {/* Teléfono */}
        <div className="field col-12 md:col-3">
          <label>Telefono</label>
          <div className="p-inputgroup">
            <Dropdown
              value={codigoPaisContacto}
              options={codigosPaises}
              onChange={(e) => setCodigoPaisContacto(e.value)}
              style={{ width: "50%" }}
            />
            <InputText
              id="telefonoContacto"
              type="text"
              value={nuevoTelefonoContacto || ""}
              onChange={handleTelefonoContactoChange}
              className="p-inputtext-sm"
              placeholder="9 999 999"
              maxLength={9}
              style={{ width: "80%" }}
            />
          </div>
        </div>

        {/* Correo */}
        <div className="field col-12 md:col-3">
          <label>Correo</label>
          <InputText
            id="correoContacto"
            type="text"
            value={nuevoCorreoContacto || ""}
            onChange={handleCorreoContactoChange}
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
            placeholder="Ingrese correo"
            maxLength={45}
          />
        </div>

        {/* Botón agregar/guardar */}
        <div className="field col-12 md:col-2 mt-4">
          <Button
            label={indiceEdicionContacto !== null ? "Guardar" : "Agregar"}
            icon={indiceEdicionContacto !== null ? "pi pi-save" : "pi pi-plus"}
            className="p-button-rounded p-button-outlined p-button-success"
            onClick={handleGuardarContacto}
          />
        </div>

        {/* Tabla de contactos */}
        <Card className="mt-2" style={{ width: "100%" }}>
          {nuevoContactos.length > 0 ? (
            <DataTable
              value={nuevoContactos}
              scrollHeight="150px"
              className="p-datatable-sm"
              tableStyle={{ fontSize: "0.875rem" }}
            >
              <Column field="tipo" header="Tipo" />
              <Column field="nombre" header="Nombre" />
              <Column field="telefono" header="Teléfono" />
              <Column field="correo" header="Correo" />
              <Column
                header="Acciones"
                body={(rowData, options) => (
                  <div className="p-d-flex p-ai-center">
                    <Button
                      icon="pi pi-pencil"
                      size="small"
                      text
                      onClick={() => handleSeleccionarContacto(options.rowIndex)}
                    />
                    {modoEdicion ? (
                      <Button
                        icon="pi pi-times"
                        size="small"
                        severity="danger"
                        text
                        onClick={() => handleDesactivarContacto(options.rowIndex)}
                      />
                    ) : (
                      <Button
                        icon="pi pi-times"
                        size="small"
                        severity="danger"
                        text
                        onClick={() => handleEliminarContacto(options.rowIndex)}
                      />
                    )}
                  </div>
                )}
              />
            </DataTable>
          ) : (
            <p className="p-text-center">No se han agregado contactos.</p>
          )}
        </Card>
      </div>

      <br />
      <div className="flex-space-between">
        <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={onPrev} />
      </div>
    </div>
  );
};

export default StepContactoForm;
